import request from '@/axios/request.js'

// 获取首页内容
export function getIndexPageList () {
    return request({
        url: '/api/index',
        method: 'get'
    })
}

// 热门搜索关键字获取
export function getKeyWord () {
    return request({
        url: '/api/search/keyword',
        method: 'get'
    })
}

// 热门搜索（取热门系列，与小程序一致）
export function getHotSearchProducts () {
    return request({
        url: '/api/products/hotV2',
        method: 'get'
    })
}

// 获取商品列表
export function getProducts (params) {
    // {
    //     'isIntegral': 0, // 是否积分兑换商品 0否  1是
    //     'keyword': '', // 关键
    //     'news': '', // 是否新品  0否  1是
    //     'priceOrder': '', // 价格排序  desc正序  asc倒序
    //     'salesOrder': '', // 销量排序
    //     'sid': '', // 分类ID
    //     'type': '', // 类别 不传
    //     'limit': 10,
    //     'page': 1
    // }
    return request({
        url: '/api/products',
        method: 'get',
        params
    })
}

// 普通商品详情
export function getNormalProductDetail (id) {
    return request({
        url: `/api/product/detail/${id}`,
        method: 'get'
    })
}

// 商品详情海报
export function getProductPoster (id, params) {
    return request({
        url: `/api/product/poster/${id}`,
        method: 'get',
        params
    })
}

// 获取分类id
export function getCategory () {
    return request({
        url: '/api/category',
        method: 'get'
    })
}

// 热门推荐
export function getHotProduct () {
    return request({
        url: '/api/product/hot',
        method: 'get'
    })
}

export function getCanvasData (params) {
    return request({
        url: '/api/getCanvas',
        method: 'get',
        params
    })
}
